import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

function ResponsibleUse() {
  return (
    <div className="container">
      <div style={{ position: "relative" }}>
        <Link to="/" className="go-to-home-link">Go to home</Link>
        <h1 className="title">Responsible Use</h1>
      </div>

      <div className="transit-description">
        <p>
          SecurityTransit.com is an academic research and educational platform designed to support cybersecurity analysis of Intelligent Transportation Systems (ITS). The platform provides structured mappings between ARC-IT service packages, MITRE ATT&CK® techniques, MITRE mitigations, and NIST SP 800-53 security controls to facilitate cybersecurity research, education, and decision support.
        </p>
        <p>
          The information provided is intended for informational and analytical purposes only. It should not be considered a substitute for organization-specific cybersecurity assessments, professional judgment, engineering analysis, or regulatory compliance requirements. Users are responsible for independently evaluating the applicability of the information to their own operational environments before implementing any security measures or making operational decisions.
        </p>
        <p>
          The platform currently supports the ARC-IT PT03 (Dynamic Transit Operations) and PT05 (Transit Security) service packages and will continue to evolve through ongoing research and development.
        </p>
      </div>
    </div>
  );
}

export default ResponsibleUse;
